
import Vue from 'vue'
const p = {
  state: {
    college: [], // 评价范围的院系下拉框
    teacher: [] // 评价范围的选择教师穿梭框
  },
  mutations: {
    'SET_COLLEGE' (state, array) {
      state.college = array
    },
    'SET_TEACHER' (state, array) {
      state.teacher = array
    }
  },
  actions: {
    get_college (context) {
      const _this = Vue.prototype
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      userInfo.clientCategory = window.clientCategory
      userInfo.pageNum = 1
      userInfo.pageSize = 0
      _this.requestData(_this.$requesturl.userinfoDepartment, userInfo, 'get').then(function (res) {
        if (res.code === '40001') {
          context.commit('SET_COLLEGE', res.content.list)
        } else {
          // console.log('get_college 请求失败! ' + res.message + ' : ' + res.otherMsg)
        }
      })
    },
    get_teacher ({ commit }) {
      const _this = Vue.prototype
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      userInfo.clientCategory = window.clientCategory
      userInfo.pageNum = 1
      userInfo.pageSize = 0
      let data = encodeURI(JSON.stringify(userInfo))
      _this.requestData(_this.$requesturl.transferSelectTeacher, { data }, 'get').then(function (res) {
        if (res.code === '40001') {
          let y = res.content.list.map((item, index) => {
            item.key = index + 1
            item.label = item.teacherName
            return item
          })
          commit('SET_TEACHER', y)
        } else {
          // console.log('get_teacher 请求失败! ' + res.message + ' : ' + res.otherMsg)
        }
      })
    }
  }
}
export default p



// WEBPACK FOOTER //
// ./src/store/modules/projectRange.js